/* eslint-disable prettier/prettier */
import React from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../redux/configureStore';
import Frame from '../../../../../../shared/components/Frame';
import theme from '../../../../../../styles/theme';
import Text from './components/Text';

function CardTotalDebits() {
  const outstandingDebitsContext = useSelector(
    (reducer: IReducer) => reducer.outstandingDebitsApp
  );

  const accountDebitsArray = outstandingDebitsContext.debits;

  let total = 0;
  accountDebitsArray.forEach((item) => {
    total += Number(item.value);
  });

  return (
    <Frame.Default
      isActive={
        outstandingDebitsContext.gotSuccess && outstandingDebitsContext.isActive
      }
      color="white"
      margin="0.5rem 0 1rem 0"
      padding="0.5rem 0 0 0"
      width="100%"
      justifyContent="center"
      backgroundColor={theme.colors.red}>
      <Text.Value>
        {total.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })}
      </Text.Value>
    </Frame.Default>
  );
}

export default CardTotalDebits;
